import React from 'react';
import { LikeCard } from '../../molecules/LikeCard';
import type { Like } from '../../../services/likesService';

export interface LikesListProps {
  likes: Like[];
  deletingId: number | null;
  onDeleteClick: (like: Like) => void;
}

export const LikesList = ({ likes, deletingId, onDeleteClick }: LikesListProps) => {
  return (
    <div className="space-y-4 mb-6">
      {likes.map((like) => (
        <LikeCard
          key={like.id}
          like={like}
          deletingId={deletingId}
          onDeleteClick={onDeleteClick}
        />
      ))}
    </div>
  );
};
